import * as React from "react";

type Props = {
  titleButton?: string;
  secondTitleButton?: string;
  thirdTitleButton?: string;
  locationButton?: string;
  secondLocationButton?: string;
  thirdLocationButton?: string;
  title: string;
  subtitle?: string;
  buttonDisabled?: boolean;
  showIcon?: boolean;
};

const Header: React.FunctionComponent<Props> = ({
  titleButton,
  secondTitleButton,
  thirdTitleButton,
  locationButton,
  secondLocationButton,
  thirdLocationButton,
  title,
  subtitle,
  buttonDisabled,
  showIcon = true,
}: Props): JSX.Element => {
  const visibleButtons = [
    titleButton && !buttonDisabled,
    secondTitleButton && !buttonDisabled,
    thirdTitleButton && !buttonDisabled,
  ].filter(Boolean);

  const hasButtons =
    !buttonDisabled &&
    (titleButton || secondTitleButton || thirdTitleButton);

  const renderButtons = () => (
    <>
      {titleButton && !buttonDisabled && (
        <a href={locationButton} className="btn btn-primary me-2 mb-2">
          {titleButton}
        </a>
      )}
      {secondTitleButton && !buttonDisabled && (
        <a href={secondLocationButton} className="btn btn-primary me-2 mb-2">
          {secondTitleButton}
        </a>
      )}
      {thirdTitleButton && !buttonDisabled && (
        <a href={thirdLocationButton} className="btn btn-primary mb-2">
          {thirdTitleButton}
        </a>
      )}
    </>
  );

  if (visibleButtons.length === 1) {
    return (
      <div className="header__top-bar">
        <div className="header__container">
          <i className="fal fa-book-open fa-6x header__icon" />
          <h1 className="header__title">{title}</h1>
          {subtitle && (
            <h3 className="header__subtitle">Description:{subtitle}</h3>
          )}
        </div>
        <div>
          {titleButton && !buttonDisabled && (
            <a href={locationButton} className="btn btn-primary">
              {titleButton}
            </a>
          )}
          {secondTitleButton && !buttonDisabled && (
            <a href={secondLocationButton} className="btn btn-primary ml-1">
              {secondTitleButton}
            </a>
          )}
          {thirdTitleButton && !buttonDisabled && (
            <a href={thirdLocationButton} className="btn btn-primary ml-1">
              {thirdTitleButton}
            </a>
          )}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex flex-col gap-4 !pl-0 pt-4 pb-4">
        {showIcon ? (
          <div className="header__container">
            <i className="fal fa-book-open fa-6x header__icon" />
            <h1 className="header__title">{title}</h1>
            {subtitle && (
              <h3 className="header__subtitle">Description: {subtitle}</h3>
            )}
          </div>
        ) : (
          <h1 className="header__title" style={{ marginLeft: 0 }}>
            {title}
          </h1>
        )}
      </div>

      {hasButtons && (
        <div className="flex flex-wrap mt-4">
          {titleButton && (
            <a href={locationButton} className="btn btn-primary me-2 mb-2">
              {titleButton}
            </a>
          )}
          {secondTitleButton && (
            <a
              href={secondLocationButton}
              className="btn btn-primary me-2 mb-2"
            >
              {secondTitleButton}
            </a>
          )}
          {thirdTitleButton && (
            <a href={thirdLocationButton} className="btn btn-primary mb-2">
              {thirdTitleButton}
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default Header;
